import { IScreenLockerState, screenLockerAT } from "./ScreenLockerModel";

export function screenLockerReducer(
    state = { locks: [] } as IScreenLockerState,
    action
): IScreenLockerState {
    switch (action.type) {
        case screenLockerAT.lock:
            return {
                lockedOn: state.lockedOn ?? action.lockTime,
                locks: state.locks.concat(action.lockGuid),
            };

        case screenLockerAT.unlock:
            const locks = state.locks.filter(x => x !== action.lockGuid);
            return locks.length
                ? {
                      lockedOn: state.lockedOn,
                      locks,
                  }
                : { locks };

        default:
            return state;
    }
}
